import store from '@/store/index';

/**
 * @description 七鱼客服接入代码
 */
function initQiYu() {
  // eslint-disable-next-line func-names
  (function (w, d, n, a, j) {
    // eslint-disable-next-line func-names
    w[n] = w[n] || function () {
      // eslint-disable-next-line prefer-rest-params
      (w[n].a = w[n].a || []).push(arguments);
    };
    j = d.createElement('script');
    j.async = true;
    j.src = 'https://qiyukf.com/script/fc508e22ee7df35c4bc57d5d62e4b3cd.js?hidden=1';
    d.body.appendChild(j);
  }(window, document, 'ysf'));
}

/**
 * @description 启动七鱼客服
 * @param {number} userId 用户ID
 * @param {string} nickName 用户名
 */
export default function startQiYuService(userId, nickName) {
  if (store.state.qiYu.isStart) {
    return;
  }

  if (!userId) {
    return;
  }

  initQiYu();

  if (!nickName) {
    nickName = '匿名';
  }

  // eslint-disable-next-line no-undef
  ysf('onready', () => {
    // eslint-disable-next-line no-undef
    ysf('config', {
      uid: userId,
      name: `${nickName}@${userId}`,
      success() {
        // 将七鱼客服启动成功的信息保存到vuex中
        store.commit('SET_QIYU', { isStart: true });

        // 监听
        // eslint-disable-next-line no-undef
        ysf('onunread', (result) => {
          // 未读消息数量和本地保存的数量不一致，则更新
          if (result.total !== store.state.qiYu.unreadNum) {
            store.commit('SET_QIYU', { unreadNum: result.total });
          }
        });

        // 获取
        // eslint-disable-next-line no-undef
        const result = ysf('getUnreadMsg');

        // 未读消息数量和本地保存的数量不一致，则更新
        if (result.total !== store.state.qiYu.unreadNum) {
          store.commit('SET_QIYU', { unreadNum: result.total });
        }
      },
      error(err) {
        console.error(err, 'ysf config error');
      }
    });
  });
}
